// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__GbsJ1","rotation":"Spinner_rotation__pdzpk"};